exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../node_modules/css-loader/dist/cjs.js!./assets/css/reset.css"), "");
// Module
exports.push([module.id, "body{margin:0;background:#f3f4f8}#app{font-family:\"Avenir\", Helvetica, Arial, sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50}\n", ""]);
